export default import.meta.ROLLDOWN_FILE_URL_JE6eecr0B5KOWbFIO9yPFw